// i18n.js imports only this file, never the barrel — the barrel pulls react-query/Request into bootstrap.
import * as schemes from "./seedBundles/schemes";
import * as farmerVerify from "./seedBundles/farmerVerify";
import * as homescreen from "./seedBundles/homescreen";
import * as common from "./seedBundles/common";
import * as assets from "./seedBundles/assets";
import * as agriInput from "./seedBundles/agriInput";
import * as weather from "./seedBundles/weather";
import * as advisories from "./seedBundles/advisories";
import * as helpSupport from "./seedBundles/helpSupport";

const bundles = [common, schemes, farmerVerify, homescreen, assets, agriInput, weather, advisories, helpSupport];

export const rewampSeedEn = Object.assign({}, ...bundles.map((b) => b.en));
export const rewampSeedHi = Object.assign({}, ...bundles.map((b) => b.hi));
